export const FormContentHeader: React.FC<{
  label: string;
  id?: string;
}> = (props) => {
  return (
    <h1
      className="
        rounded-[5px]
        text-center
        pt-[5px]
        pb-[5px]
        mt-[8px]
        mb-[8px]
        "
      style={{ background: 'var(--c-form-header-background)' }}
      id={props.id}
    >
      <p className="text-[--c-form-header-text] font-semibold">{props.label}</p>
    </h1>
  );
};
